module.exports = __webpack_public_path__ + "static/delimiter_desktop-5f6adce763d88ea1004ab1e7628492a3.png";